import React from "react";
import Grain from "../Grain/Grain";
import Reveal from "../Reveal/Reveal";
import { useAppLinks } from "../../hooks/useAppLinks";
import "./styles.css";

const Cta = () => {
  const links = useAppLinks();

  return (
    <section className="cta dossie">
      <div className="margin-line right" />
      <Grain variant="paper" />
      <Reveal className="cta-box">
        <div className="glow glow-a" style={{ top: -200, left: "10%" }} />
        <div className="glow glow-b" style={{ bottom: -200, right: "5%" }} />
        <div className="gridlines" />
        <div className="sq" style={{ width: 80, height: 80, top: "14%", left: "8%" }} />
        <div className="sq" style={{ width: 56, height: 56, bottom: "16%", right: "12%", animationDelay: "3s" }} />
        <Grain variant="hard" />
        <div className="inner">
          <span className="stamp stamp-blue">Aprovado</span>
          <h2 className="display">Menos papel. Mais cirurgia.</h2>
          <p>Comece agora e sinta a diferença já no próximo pedido.</p>
          <a className="btn btn-light" href={links.signup}>
            Criar conta grátis
          </a>
        </div>
      </Reveal>
    </section>
  );
};

export default Cta;
